(function(){
'use strict';
var params=new URLSearchParams(location.search);
if(!/^\/products\//.test(location.pathname)||params.get('ys_finder')!=='1')return;
var position=params.get('ys_finder_position');
if(!/^[1-9][0-9]*$/.test(position||''))return;
var properties={'_ys_finder':'1','_ys_finder_position':position};
function isCartForm(form){return form&&form.matches&&form.matches('form[action*="/cart/add"]');}
function markForm(form){
 if(!isCartForm(form))return;
 Object.keys(properties).forEach(function(k){
  var el=Array.prototype.find.call(form.querySelectorAll('input[name="properties['+k+']"]'),function(x){return x.form===form;});
  if(!el){el=document.createElement('input');el.type='hidden';el.name='properties['+k+']';form.appendChild(el);}
  el.value=properties[k];
 });
}
function markAll(){document.querySelectorAll('form[action*="/cart/add"]').forEach(markForm);}
document.addEventListener('submit',function(e){markForm(e.target);},true);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',markAll);else markAll();
var ysQ=false;var observer=new MutationObserver(function(){if(ysQ)return;ysQ=true;requestAnimationFrame(function(){ysQ=false;markAll();});});
observer.observe(document.documentElement,{childList:true,subtree:true});
var nativeFetch=window.fetch;
window.fetch=function(input,init){
 try{
  var url=typeof input==='string'?input:input&&input.url;
  if(url&&/\/cart\/add(?:\.js)?(?:\?|$)/.test(new URL(url,location.origin).pathname)&&init&&init.body){
   var body=init.body;
   if(body instanceof FormData){
    Object.keys(properties).forEach(function(k){body.set('properties['+k+']',properties[k]);});
   }else if(body instanceof URLSearchParams){
    Object.keys(properties).forEach(function(k){body.set('properties['+k+']',properties[k]);});
   }else if(typeof body==='string'&&(!init.headers||!/x-www-form-urlencoded/i.test(JSON.stringify(init.headers)))){
    var obj=JSON.parse(body);
    if(obj&&typeof obj==='object'){
     if(Array.isArray(obj.items))obj.items.forEach(function(item){if(item&&typeof item==='object')item.properties=Object.assign({},item.properties||{},properties);});
     else if(obj.id)obj.properties=Object.assign({},obj.properties||{},properties);
     init=Object.assign({},init,{body:JSON.stringify(obj)});
    }
   }
  }
 }catch(e){}
 return nativeFetch.call(this,input,init);
};
})();